import { Collection } from '@msw/data'
import { membershipSchema } from 'app/src/msw/membership/schemas/membership'
import type { membershipApi } from 'app/src/services/welfareportal'

const membershipCollection = new Collection({
  schema: membershipSchema,
  // extensions: [persist()],
})

export { membershipCollection }

export const createMembershipSeed = async (overrides?: { firstName?: string; lastName?: string; email?: string }) => {
  const existingData = await membershipCollection.findMany()

  console.log('MSW: Checking existing Membership Info data, found', existingData.length)

  if (existingData.length > 0) {
    return
  }

  const jsonData = await (await fetch('./data/membership/membership.json')).json()

  jsonData.items.forEach(async (item: membershipApi.Membership) => {
    if (overrides?.firstName) {
      item.userFirstName = overrides.firstName
    }
    if (overrides?.lastName) {
      item.userLastName = overrides.lastName
    }
    if (overrides?.email) {
      item.userEmail = overrides.email
    }
    const createdMembership = await membershipCollection.create(item)
    console.log('createMembershipSeed', createdMembership)
  })
  console.log('MSW: Seeding Membership Info data')
}

export const clearMembershipSeed = async () => {
  const existingData = await membershipCollection.findMany()
  existingData.forEach(async (item) => {
    await membershipCollection.delete(item)
  })
  console.log('MSW: Clearing Membership data')
}
